var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-coin"},[_c('img',{staticClass:"l-img",attrs:{"src":require("./images/l-coin.png"),"alt":"COIN"}}),_vm._v(_vm._s(_vm.lilyCoin)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }